import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { TimeInput } from '@modules/admin/schedules2/TimeInput'

export class Shift extends Component {
  static propTypes = {
    start: PropTypes.instanceOf(Date),
    end: PropTypes.instanceOf(Date),
    date: PropTypes.instanceOf(Date),
    active: PropTypes.bool,
  }

  static defaultProps = {
    date: new Date(),
  }

  handleAccept = () => {
    let shift = this.state

    if (shift.start > shift.end) {
      shift.end.setDate(shift.start.getDate() + 1)
    } else if (shift.start <= shift.end) {
      shift.end.setDate(shift.start.getDate())
    }

    this.props.handleShift(shift)
  }

  handleDelete = () => {
    let shift = this.state
    this.props.deleteShift(shift)
  }

  onDateChange = ({ start = this.state.start, end = this.state.end }) => {
    return this.setState({ start, end })
  }

  constructor(props) {
    super()
    this.state = {
      start: props.date,
      end: props.date,
      ...props,
    }
  }

  render() {
    if (!this.state) return null
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-around',
          border: this.props.active ? '5px solid red' : 'none',
        }}
      >
        <TimeInput
          input={{
            value: this.state.start,
            onChange: (date) => this.onDateChange({ start: date }),
          }}
        />

        <TimeInput
          input={{
            value: this.state.end,
            onChange: (date) => this.onDateChange({ end: date }),
          }}
        />

        <button type="button" onClick={this.handleAccept}>
          Aceptar
        </button>
        {this.state.id && (
          <button type="button" onClick={this.handleDelete}>
            Borrar
          </button>
        )}
      </div>
    )
  }
}

export default Shift
